import { DatePipe } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { Paginator } from 'primeng/paginator';
import { CommonService } from 'src-adisco/services/common.service';
import { HomepageService } from 'src-adisco/services/homepage.service';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { UserService } from 'src/app/admin/core/services/user.service';
import { NotificationService } from 'src/app/services/notification.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { v4 as uuidv4 } from 'uuid';

interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}
@Component({
  selector: 'app-customer-prospect',
  templateUrl: './customer-prospect.component.html',
  styleUrls: ['./customer-prospect.component.css'],
  providers: [MessageService, ConfirmationService],
})
export class CustomerProspectComponent implements OnInit, OnDestroy {
  @HostListener('document:click', ['$event']) onDocumentClick(event: any): void {
    if (!this.clickInsideDropdown) {

      for (let i = 0; i < this.showDropdownArray.length; i++) {
        if (this.showDropdownArray[i]) {
          const dropdownElement = document.getElementById('p-dropdown-active');
          if (!dropdownElement?.contains(event.target)) {
            this.showDropdownArray[i] = false;
          }
        }
      }
    }
    this.clickInsideDropdown = false;
  }
  @ViewChild('paginator', { static: false }) paginator: Paginator;
  formPagination!: FormGroup;
  infoCustomerForm: FormGroup;
  filterForm: FormGroup;
  items: MenuItem[];
  visibleEdit: boolean = false;
  visibleRow: boolean = false;
  isShow: boolean = false;
  showListBtn = false;
  list: any[] = [];
  listRows: any[] = [
    10, 20, 30
  ]
  first1: number = 0;

  rows1: number = 10;

  first2: number = 0;

  rows2: number = 10;

  first3: number = 0;

  rows3: number = 10;

  totalRecords: number = 120;

  rows: number = 1; // Số hàng mặc định mỗi trang
  visible: boolean = false;
  userId = localStorage.getItem('userid');
  currentUser: any;
  rowsPerPageOptions: number[] = [1, 2, 3];
  listIdCustomer: any[] = [];
  listCustomer: any[] = [];
  currentVisibleRow: number = -1;
  showDropdownArray: boolean[] = [];
  clickInsideDropdown: boolean = false;
  nameFile: string = '';
  logoImage: any;
  currentItemCustomer: any;
  listCountry: any[] = [];
  listTypeUser: any[] = [];
  totalPages = 0;
  currentPage = 1;
  isUpdating = false;
  isShowForm: boolean = true;

  // export
  types: any[] = [
    { label: 'CSV', value: 'csv' },
    { label: 'XLS', value: 'xls' },
    { label: 'XLSX', value: 'xlsx' }
  ];

  selectedType: string = 'csv';
  file: File | null = null;

  inProgress: boolean = false;
  refreshListTable: boolean = false;

  progress: any = null;
  records: any[] | null = null;
  fileId: string;
  nbIgnored: number = 0;
  nbSuccess: number = 0;
  nbWarnings: number = 0;
  nbErrors: number = 0;
  nbTotal: number = 0;

  constructor(private _fb: FormBuilder,
    private _commonService: CommonService,
    private dynamicDocumentService: DynamicDocumentService,
    private httpClientService: HttpclientService,
    private _homepageService: HomepageService,
    private datePipe: DatePipe,
    private _messageService: MessageService,
    public userService: UserService,
    private readonly _notificationService: NotificationService,
  ) {
  }
  public ngOnDestroy(): void {
    this._notificationService.unsubscribeImportFileNotification();
  }
  ngAfterViewInit() {
    this.updatePaginators(this.currentPage);
  }
  ngOnInit() {
    this.initForm();
    this.getInfoProfile();
    this.getListCountry();
    this.getListTypeOfLegalEntity();
  }
  updatePaginators(page: number) {
    this.paginator?.changePage(page);
  }
  initForm(): void {
    this.formPagination = this._fb.group({
      rows: [20],
      page: [1],
    });
    this.filterForm = this._fb.group({
      code: '',
      companyName: '',
      address: '',
      typeOfCustomer: '',
    });
    this.infoCustomerForm = this._fb.group({
      code: '',
      companyName: '',
      siret: '',
      vat: '',
      logo: '',
      address: '',
      additionalAddress: '',
      postcode: '',
      city: '',
      country: '',
      phone: '',
      fax: '',
      email: '',
      website: '',
      typeOfLegalEntity: '',
      typeOfCustomer: null
    });
  }
  patchValueForm(data: any): void {
    this.infoCustomerForm.patchValue({
      code: data?.code,
      companyName: data?.companyName,
      siret: data?.siret,
      vat: data?.vat,
      // logo: data?.logo,
      address: data?.address,
      additionalAddress: data?.additionalAddress,
      postcode: data?.postcode,
      city: data?.city,
      country: data?.country?.labels?.fr_FR,
      phone: data?.phone,
      fax: data?.fax,
      email: data?.email,
      website: data?.website,
      typeOfLegalEntity: data?.typeOfLegalEntity?.parameterId,
      // status: data?.status?.value,
    })
  }
  getListCountry(): void {
    this._homepageService.getCountry().subscribe({
      next: (res) => {
        this.listCountry = res.map((item: any) => ({
          ...item,
          label: item.mapLocalLibelle.fr_FR
        }));
      },
      error: (error) => { },
    });
  }

  getListTypeOfLegalEntity(): void {
    this._commonService.getTypeOfCustomer().subscribe({
      next: (res) => {
        this.listTypeUser = res.map((type: any) => ({ ...type, label: type?.mapLocalLibelle['fr_FR'] ?? type?.valeur }));
      },
      error: (error) => { },
    });
  }
  getInfoProfile(): void {
    this._commonService.getUser(this.userId).subscribe({
      next: (res) => {
        this.currentUser = res;
        if (this.currentUser?.linkToLegalEntity) {
          this.getInfoMember(this.currentUser?.linkToLegalEntity?.documentId);
        }
      },
      error: (error) => { },
    });
  }
  getInfoMember(id: any): void {
    this.listIdCustomer = [];
    this._commonService.getInfoMember(id).subscribe({
      next: (res) => {
        // this.getListSuppliers(this.currentUser?.linkToLegalEntity?.value);
        res?.linkToCustomers.forEach((item: any) => {
          this.listIdCustomer.push(item.documentId);
        });
        if (this.listIdCustomer && this.listIdCustomer?.length > 0) {
          this.getListCustomer(this.listIdCustomer);
        }
      },
      error: (error) => { },
    });
  }
  getListSuppliers(ids: any): void {
    let filters = [
      {
        fieldName: 'linkToCustomers',
        conditions: [
          {
            type: 'EQUALS',
            value: ids,
          },
        ],
      },
      // {
      //   fieldName: 'status',
      //   conditions: [
      //     {
      //       type: 'EQUALS',
      //       value: 'Publié',
      //     },
      //   ],
      // },
    ];
    this.dynamicDocumentService
      .find({
        collectionName: 'dynamic_legal_entity',
        filters: filters,
        sorts: {},
        page: this.formPagination.value.page,
        pageSize: this.formPagination.value.rows,
      })
      .subscribe((res: any) => {
        this.listCustomer = res?.content;
        this.totalRecords = res.totalElements
        this.rows3 = res.size;
        this.totalPages = Math.ceil(this.totalRecords / this.rows3);
      });
  }
  getListCustomer(ids: any[]): void {
    this._commonService.listCustomer(ids).subscribe({
      next: (res) => {
        this.listCustomer = res;

      },
      error: (error) => { },
    });
  }
  toggleShowIcon() {
    this.isShow = !this.isShow;
  }
  onPageChange(event: PageEvent) {
    if (this.isUpdating) {
      return;
    }
    this.isUpdating = true;
    this.currentPage = event.page;
    this.rows3 = this.formPagination.value.rows;
    this.formPagination.patchValue({
      page: event.page + 1
    })
    this.paginator?.changePage(this.currentPage);
    // this.getListSuppliers(this.currentUser?.linkToLegalEntity?.value);
    if (this.listIdCustomer && this.listIdCustomer?.length > 0) {
      this.getListCustomer(this.listIdCustomer);
    }
    this.isUpdating = false;
  }
  toggleShow(): void {
    this.showListBtn = !this.showListBtn;
  }
  filterRows(): void {
    this.formPagination.patchValue({
      rows: this.formPagination.value.rows,
      // page: 1,
    })
    // this.getListSuppliers(this.currentUser?.linkToLegalEntity?.value);
    if (this.listIdCustomer && this.listIdCustomer?.length > 0) {
      this.getListCustomer(this.listIdCustomer);
    }
    this.paginator?.changePageToFirst(event);
  }
  showDialog() {
    this.visible = true;
  }

  export() {
    let filters = [
      {
        fieldName: 'id',
        conditions: [
          {
            type: 'IN',
            value: this.listIdCustomer ?? [],
          },
        ],
      }
    ];


    const exportFileRequest: any = {
      filters: filters,
      fields: [
        "code",
        "companyName",
        "siret",
        "address",
        "postcode",
        "city",
        "phone",
        "fax",
        "email",
        "website",
        "linkToNaturalPersons",
      ],
      relationFields: {
        "linkToNaturalPersons": [
          "civility",
          "lastName",
          "firstName",
          "job",
          "email",
          "mobile",
          "phone"
        ]
      },
      sorts: { companyName: "asc" },
      locales: ["fr_FR"],
    };

    let documentName = 'dynamic_legal_entity';
    let fileExtension = 'xlsx';
    this.dynamicDocumentService
      .exportFileWithContact(documentName, fileExtension, exportFileRequest)
      .subscribe((data: Blob) => {
        const blob = new Blob(
          [data],
          { type: 'application/vnd.ms-excel' }
        );
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = `export.xlsx`;
        link.click();
        URL.revokeObjectURL(objectUrl);
      });
  }

  update(item: any) {
    this.infoCustomerForm.reset();
    this.nameFile = '';
    this.visibleEdit = true;
    this.currentItemCustomer = item;
    if (item?.logo && item?.logo[0]) {
      this.logoImage = item?.logo[0];
      this.nameFile = item?.logo[0]?.name;
    }
    this.patchValueForm(this.currentItemCustomer);
  }
  delete(item: any) {
    this.visibleRow = true;
    this.currentItemCustomer = item;
  }
  closePopup() {
    this.visibleRow = false;
  }

  confirmDelete() {
    this._commonService.deleteCustomer(this.currentItemCustomer?.id).subscribe({
      next: (res) => {
        this.visibleRow = false;
        // this.getListSuppliers(this.currentUser?.linkToLegalEntity?.value);
        if (this.listIdCustomer && this.listIdCustomer?.length > 0) {
          this.getListCustomer(this.listIdCustomer);
        }
      },
      error: (error) => { },
    });
  }

  toggleDropdown(rowIndex: number): void {
    if (this.currentVisibleRow === rowIndex) {
      this.showDropdownArray[rowIndex] = !this.showDropdownArray[rowIndex];
    } else {
      for (let i = 0; i < this.showDropdownArray.length; i++) {
        this.showDropdownArray[i] = false;
      }
      this.showDropdownArray[rowIndex] = true;
    }
    this.currentVisibleRow = rowIndex;
    this.clickInsideDropdown = true;
  }
  selectImage(event: any): void {
    let selectedFile = event.target.files[0];
    if (!selectedFile) {
      return;
    }
    this.nameFile = selectedFile?.name;
    this.logoImage = selectedFile;
    this.uploadFile(selectedFile);
  }
  uploadFile(file: any) {
    const formData = new FormData();
    formData.append('file', file);

    this.httpClientService
      .postWithHeader(formData, {}, '/resource-files')
      .subscribe({
        next: (resourceFile) => {
          // this.infoCustomerForm.patchValue({
          //   logo: this.convertFieldImage(resourceFile)
          // })
          this.currentItemCustomer.logo = [];
          this.currentItemCustomer.logo = [this.convertFieldImage(resourceFile)];
        },
        error: (error) => {
        },
      });
  }
  convertFieldImage(file: any) {
    return {
      resourceFileId: file.id,
      name: file.name,
      url: file.url
    };
  }
  mapItem(item: any) {
    return {
      parameterId: item.id,
      value: item.valeur,
      labels: {
        en_GB: item.mapLocalLibelle?.en_GB,
        es_ES: item.mapLocalLibelle?.es_ES,
        fr_FR: item.mapLocalLibelle?.fr_FR,
        de_DE: item.mapLocalLibelle?.de_DE
      }
    };
  }
  saveUpdateInfoCustomer(): void {
    let itemCountry: any = '';
    if (this.infoCustomerForm.value.country) {
      const foundItem = this.listCountry.find(item => item.mapLocalLibelle?.fr_FR === this.infoCustomerForm.value.country);
      if (foundItem) {
        itemCountry = this.mapItem(foundItem);
      }
    }
    if (!this.infoCustomerForm.valid || !this.currentItemCustomer) {
      return;
    }
    if (this.infoCustomerForm.value.typeOfLegalEntity) {
      this.currentItemCustomer.typeOfLegalEntity = [this.infoCustomerForm.value.typeOfLegalEntity];
    }
    // this.currentItemCustomer.typeOfLegalEntity = [this.infoCustomerForm.get('typeOfLegalEntity')] || null
    this.currentItemCustomer.code = this.infoCustomerForm.get('code')?.value || '';
    this.currentItemCustomer.companyName = this.infoCustomerForm.get('companyName')?.value || '';
    this.currentItemCustomer.siret = this.infoCustomerForm.get('siret')?.value || '';
    this.currentItemCustomer.vat = this.infoCustomerForm.get('vat')?.value || '';
    // this.currentItemCustomer.logo = this.infoCustomerForm.get('logo')?.value || '';
    this.currentItemCustomer.address = this.infoCustomerForm.get('address')?.value || '';
    this.currentItemCustomer.additionalAddress = this.infoCustomerForm.get('additionalAddress')?.value || '';
    this.currentItemCustomer.postcode = this.infoCustomerForm.get('postcode')?.value || '';
    this.currentItemCustomer.city = this.infoCustomerForm.get('city')?.value || '';
    this.currentItemCustomer.country = itemCountry || '';
    this.currentItemCustomer.phone = this.infoCustomerForm.get('phone')?.value || '';
    this.currentItemCustomer.fax = this.infoCustomerForm.get('fax')?.value || '';
    this.currentItemCustomer.email = this.infoCustomerForm.get('email')?.value || '';
    this.currentItemCustomer.website = this.infoCustomerForm.get('website')?.value || '';
    this.currentItemCustomer.updatingDate = this.datePipe.transform(Date.now(), "yyyy-MM-dd'T'00:00:00");
    this.currentItemCustomer.creationDate = this.datePipe.transform(
      this.currentUser.creationDate,
      "yyyy-MM-dd'T'HH:mm:ss"
    );
    this.dynamicDocumentService
      .saveDocument('dynamic_legal_entity', this.currentItemCustomer, true)
      .subscribe({
        next: (res) => {
          this._messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: "Les détails de l'utilisateur ont été enregistrés avec succès",
            life: 3000
          });
          this.visibleEdit = false;
          // if (this.currentUser?.linkToLegalEntity) {
          //   this.getListSuppliers(this.currentUser?.linkToLegalEntity?.value);
          // }
          if (this.listIdCustomer && this.listIdCustomer?.length > 0) {
            this.getListCustomer(this.listIdCustomer);
          }
          this.patchValueForm(res);
        },
        error: (err) => {
          this._messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: "Échec de l'enregistrement des détails de l'utilisateur",
            life: 3000
          });
        }
      });
  }
  clearFilter() {
    this.filterForm.reset();
    // this.getListSuppliers(this.currentUser?.linkToLegalEntity?.value);
    this.getListCustomer(this.listIdCustomer);
  }
  filter(): void {
    let filters = [
      // {
      //   fieldName: 'linkToCustomers',
      //   conditions: [
      //     {
      //       type: 'EQUALS',
      //       value: this.currentUser?.linkToLegalEntity?.value,
      //       "minValue": "",
      //       "maxValue": ""
      //     },
      //   ],
      // },
    ];

    if (this.listIdCustomer?.length) {
      filters.push({
        fieldName: 'id',
        conditions: [
          {
            type: 'IN',
            value: this.listIdCustomer,
            "minValue": "",
            "maxValue": ""
          },
        ],
      },)

    }
    if (this.filterForm.value.code) {
      filters.push({
        "fieldName": "code",
        "conditions": [
          {
            "type": "CONTAINS",
            "value": this.filterForm.value.code,
            "minValue": "",
            "maxValue": ""
          }
        ]
      },)
    }
    if (this.filterForm.value.companyName) {
      filters.push({
        "fieldName": "companyName",
        "conditions": [
          {
            "type": "CONTAINS",
            "value": this.filterForm.value.companyName,
            "minValue": "",
            "maxValue": ""
          }
        ]
      },)
    }
    if (this.filterForm.value.address) {
      filters.push({
        "fieldName": "address",
        "conditions": [
          {
            "type": "CONTAINS",
            "value": this.filterForm.value.address,
            "minValue": "",
            "maxValue": ""
          }
        ]
      },)
    }
    if (this.filterForm.value.typeOfCustomer) {
      filters.push({
        "fieldName": "typeOfCustomer",
        "conditions": [
          {
            "type": "EQUALS",
            "value": this.filterForm.value.typeOfCustomer,
            "minValue": "",
            "maxValue": ""
          }
        ]
      })
    }
    this.dynamicDocumentService
      .find({
        collectionName: 'dynamic_legal_entity',
        filters: filters,
        sorts: {
          "companyName": "ASC"
        },
        page: 1,
        pageSize: 150,
      })
      .subscribe((res: any) => {
        this.listCustomer = res.content;
      });
  }
  toggleForm() {
    this.isShowForm = !this.isShowForm;
  }

  onExportTrameFile() {
    // const exportFileRequest: any = {
    //   ids: this.listIdCustomer ?? [],
    //   filters: null,
    //   locales: ["fr_FR"],
    //   isUseLabel: false
    // };

    // this.dynamicDocumentService.exportFile("dynamic_legal_entity", this.selectedType, exportFileRequest).subscribe((data: Blob) => {
    //   const blob = new Blob([data], this.selectedType === 'csv' ? { type: 'application/csv' } : { type: 'application/vnd.ms-excel' });

    //   const objectUrl = window.URL.createObjectURL(blob);

    //   const link = document.createElement('a');
    //   link.href = objectUrl;
    //   link.download = `export.${this.selectedType}`;
    //   link.click();

    //   URL.revokeObjectURL(objectUrl);
    // });

    this.export();
  }

  onImportFile($event: any): void {
    this.file = $event.target.files[0];
  }

  closeImportDialog(refresh: boolean) {
    this.visible = false;
    this.selectedType = 'csv';
    this.file = null;

    this.records = null;
    this.inProgress = false;
    this.refreshListTable = false;

    this.progress = null;
    this.records = null;
    this.fileId = '';
    this.nbIgnored = 0;
    this.nbSuccess = 0;
    this.nbWarnings = 0;
    this.nbErrors = 0;
    this.nbTotal = 0;

    if (refresh && this.currentUser) {
      this.getInfoMember(this.currentUser?.linkToLegalEntity?.documentId);
    }
  };

  public onCancel(): void {
    if (this.inProgress) {
      this.dynamicDocumentService.cancelImportFile("dynamic_legal_entity").subscribe(() => {
        if (this.records !== null) {
          this._notificationService.unsubscribeImportFileNotification();
          this.closeImportDialog(this.refreshListTable);
        }
      });
    } else {
      this._notificationService.unsubscribeImportFileNotification();
      this.closeImportDialog(this.refreshListTable);
    }
  }

  public onClose(): void {
    this._notificationService.unsubscribeImportFileNotification();
    this.closeImportDialog(this.refreshListTable);
  }

  public onSubmit(): void {
    if (this.file !== null) {
      this.refreshListTable = true;
      this.inProgress = true;
      this.fileId = uuidv4();

      this._notificationService.subscribeImportFileNotification(this.fileId, (notification: any) => {
        if (notification.type === 'IMPORT_FILE_PROGRESS') {
          this.progress = notification;
        } else if (notification.type === 'IMPORT_FILE_REPORT') {
          const report = notification.report;
          if (report !== undefined || report !== null) {
            const records: any[] = report.records;
            for (let i = 0; i < records.length; i++) {
              const record: any = records[i];
              if (record.type === 'IGNORED') {
                this.nbIgnored++;
              } else if (record.type === 'SUCCESS') {
                this.nbSuccess++;
              } else if (record.type === 'WARNING') {
                this.nbWarnings++;
              } else if (record.type === 'ERROR') {
                this.nbErrors++;
              }
              this.nbTotal++;
            }
            this.records = records;
          } else {
            this.records = null;
          }
        }
      });

      this.dynamicDocumentService.importFile("dynamic_legal_entity", this.file, this.fileId, "import-file-supplier").subscribe({
        next: () => {
        }, error: () => { }
      });
    }
  }

  public onDownloadReport(): void {
    if (this.records !== null) {
      let text = '';

      text += `Nombre de lignes traitées = ${this.nbTotal}\n`;
      text += `Nombre de lignes ignorées = ${this.nbIgnored}\n`;
      text += `Nombre de lignes validées = ${this.nbSuccess}\n`;
      text += `Nombre de lignes avec alerte = ${this.nbWarnings}\n`;
      text += `Nombre de lignes en erreur = ${this.nbErrors}\n\n`;

      for (const record of this.records) {
        if (record.type === 'IGNORED') {
          text += `${record.row} : IGNORE\n`
        } else if (record.type === 'WARNING') {
          text += `ALERTE [LIGNE ${record.row} - COLONNE ${record.column}] ${record.message}\n`;
        } else if (record.type === 'ERROR' && record.column !== undefined && record.column !== null && record.column !== '') {
          text += `ERREUR [LIGNE ${record.row} - COLONNE ${record.column}] ${record.message}\n`;
        } else if (record.type === 'ERROR' && (record.column === undefined || record.column === null || record.column === '')) {
          text += `ERREUR [LIGNE ${record.row}] ${record.message}\n`;
        }
      }

      const link = document.createElement('a');
      link.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(text);
      link.download = 'rapport.txt';
      link.click();
    }
  }
}
